module.exports = __webpack_public_path__ + "d41c92d4b8c71a4baba656e1d83487d0.svg";